module.exports = __webpack_public_path__ + "img/4-3.20477646.png";